export const RAM_SALE_PERCENT = 0.45

export const periods = [
  { period: '1', period_title: { full: 'hight_load_period_title' }, percent: '', value: 1 },
  {
    period: '3',
    period_title: { full: 'hight_load_period_title_variant2' },
    percent: '',
    value: 3,
  },
  {
    period: '6',
    period_title: { full: 'hight_load_period_title_variant3' },
    percent: '',
    value: 6,
  },
  {
    period: '12',
    period_title: { full: 'hight_load_period_title_variant3' },
    percent: '6',
    value: 12,
  },
]

export const dedicPeriods = [
  { period: '1', period_title: { full: 'hight_load_period_title' }, percent: '', value: 1 },
  {
    period: '3',
    period_title: { full: 'hight_load_period_title_variant2' },
    percent: '2',
    value: 3,
  },
  {
    period: '6',
    period_title: { full: 'hight_load_period_title_variant3' },
    percent: '4',
    value: 6,
  },
  {
    period: '12',
    period_title: { full: 'hight_load_period_title_variant3' },
    percent: '8',
    value: 12,
  },
]

export const cloudPeriods = [
  {
    period: '1',
    period_title: { full: 'day', short: 'day' },
    value: 1,
  },
  { period: '1', period_title: { full: 'hight_load_period_title', short: 'mon' }, value: 30 },
  {
    period: '3',
    period_title: { full: 'hight_load_period_title_variant2', short: 'mon' },
    value: 90,
  },
  {
    period: '6',
    period_title: { full: 'hight_load_period_title_variant3', short: 'mon' },
    value: 180,
  },
  {
    period: '12',
    period_title: { full: 'hight_load_period_title_variant3', short: 'mon' },
    value: 365,
  },
]

export const FACEBOOK_LOGIN_LINK =
  'https://api.zomro.com/billmgr?func=oauth.redirect&newwindow=yes&network=facebook&project=4&currency=153&rparams='
export const GOOGLE_LOGIN_LINK =
  'https://api.zomro.com/billmgr?func=oauth.redirect&newwindow=yes&network=google&project=4&currency=153&rparams='

// phone countries for yookassa payment method (QIWI)
export const QIWI_PHONE_COUNTRIES = [
  'az',
  'in',
  'ru',
  'kz',
  'gb',
  'ge',
  'lt',
  'tj',
  'th',
  'uz',
  'pa',
  'am',
  'lv',
  'tr',
  'md',
  'il',
  'vn',
  'ee',
  'kr',
  'kg',
]

// phone countries for yookassa payment method (SberPay)
export const SBER_PHONE_COUNTRIES = ['ru']

export const phoneErrorTypes = [
  'invalid_number',
  'invalid_country_code',
  'too_short',
  'too_long',
  'invalid_number',
]

export const PRICES_TO_BE_CONVERTED = [
  ['[data-4-banner-price]', '2.62'],
  ['[data-care-item-price]', '6.99'],
  ['[data-ddos-box-offer]', '7.91'],
  ['[data-ddos-price]', '1.02'],
  ['[vpn-data-item-price]', '3.98'],
  ['[data-wordpress-banner-price]', '2.62'],
  ['[data-vdsxl-banner-price]', '49.60'],
  ['[data-vdsxl-banner-price-old]', '62'],
  ['[data-cloud-vps-banner-price]', '3.80'],
  ['[data-cloud-premium-banner-price]', '3.80'],
  ['[data-cloud-basic-banner-price]', '5.48'],
  ['[data-banner-1-price]', '3.5'],
  ['[data-banner-2-price]', '385'],
  ['[data-banner-3-price]', '5.48'],
  ['[data-banner-4-price]', '3.98'],
  ['[data-banner-5-price]', '49'],
  ['[data-banner-6-price]', '3.80'],
  ['[data-cloud-boost-banner-price]', '7.90'],
  ['[data-main-premium-price]', '6.48'],
  ['[data-main-basic-price]', '4.80'],
  ['[data-main-dedic-price]', '49.00'],
  ['[data-main-hosting-price]', '3.50'],
  ['[data-main-cheap-price]', '2.80'],
  ['[data-main-storage-price]', '13.80'],
  ['[data-main-forex-price]', '3.98'],
  ['[data-main-builder-price]', '3.98'],

  ['[data-ispmanager-lite-price]', '5.00'],
  ['[data-ispmanager-pro-price]', '9.00'],
  ['[data-ispmanager-host-price]', '15.00'],
]

/** Selects prices with currency symbol. Examples: ₴109.28 1,2€ */
export const PRICE_REG_EXP =
  /(?:[€₴$£₽]\s?\d+(?:(?:\.|,)\d{1,4})?)|(?:\d+(?:(?:\.|,)\d{1,4})?\s?[€₴$£₽])/g

export const emailCheckRegExp = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/

export const DOMAIN_REGEX =
  /^(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?)(?:\.[a-z0-9](?:[-a-z0-9]*[a-z0-9])?)*$/

export const NEW_DEDICS = ['81', '82', 'US 1', 'US 2']

export const DEDICS_WITH_6_MONTH_PROMOTION = []

export const CLOUD_LOCATION = 13

export const FOREX_DATA_CENTERS = { eu: 15, us: 9, sg: 11 }

export const DC_DICTIONARY = {
  ['Poland']: '12',
  ['Netherlands-2']: '13',
}

export const DEDIC_DISPLAY_ORDER = ['Config 85']
